module.exports = __webpack_public_path__ + "img/ys-7.42910220.png";